/**
 * Точка входа React приложения
 * Автор: Cursor Generator
 * Описание: Инициализирует React приложение и роутинг
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { supabase } from './lib/supabase.js';
import { registerServiceWorker, subscribeToServiceWorkerMessages } from './utils/offlineUpload.js';
import App from './App';
import './index.css';

// Глобальный обработчик событий авторизации Supabase
// Важно: должен быть ДО рендеринга React, чтобы успеть перехватить PASSWORD_RECOVERY
if (supabase) {
  supabase.auth.onAuthStateChange((event, session) => {
    console.log('[Supabase Auth Event]', event);
    
    // При получении события сброса пароля - редиректим на форму
    if (event === 'PASSWORD_RECOVERY') {
      console.log('[Supabase Auth] PASSWORD_RECOVERY event - redirecting to reset form');
      // Используем replace чтобы не создавать историю
      window.history.replaceState(null, '', '/?showResetPassword=true');
      // Сохраняем флаг для HomePage
      sessionStorage.setItem('password_recovery_flow', 'true');
      // Перезагружаем страницу для применения
      window.location.reload();
    }
  });
}

// Инициализация OTA обновлений (только для мобильного)
// Обёрнуто в try-catch для предотвращения краша
try {
  if (Capacitor.isNativePlatform()) {
    // Откладываем инициализацию updater чтобы не крашить при старте
    setTimeout(async () => {
      try {
        // Регистрируем слушатель обновлений
        await CapacitorUpdater.notifyAppReady();
        console.log('[Updater] OTA обновления инициализированы');
      } catch (error) {
        console.warn('[Updater] OTA обновления недоступны:', error.message);
      }
    }, 3000); // Ждём 3 секунды после запуска
  }
} catch (error) {
  console.warn('[Main] Ошибка инициализации Capacitor:', error);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Регистрация Service Worker для оффлайн поддержки (только в production и не на мобильных)
try {
  if (!Capacitor.isNativePlatform() && import.meta.env.PROD) {
    registerServiceWorker().then(() => {
      // Подписываемся на сообщения от Service Worker
      subscribeToServiceWorkerMessages((message) => {
        if (message.type === 'RESUME_UPLOAD') {
          console.log('[Main] Получено сообщение о возобновлении загрузки:', message.data);
          // Здесь можно добавить логику возобновления загрузки
          // Например, через глобальный event или state manager
          window.dispatchEvent(new CustomEvent('resumeUpload', { detail: message.data }));
        }
      });
    });
  }
} catch (error) {
  console.warn('[Main] Ошибка регистрации Service Worker:', error);
}




